import React from 'react';

const TextBold = ({ color, onClick }) => {
  return (
    <svg
      id='Password'
      xmlns='http://www.w3.org/2000/svg'
      width='11'
      height='19'
      viewBox='0 0 11 19'
      onClick={onClick}
      cursor='pointer'
    >
      <text
        id='Password-2'
        data-name='Password'
        transform='translate(0 15)'
        fill={color}
        font-size='16'
        font-family='Roboto-Bold, Roboto'
        font-weight='700'
        letter-spacing='0em'
      >
        <tspan x='0' y='0'>
          B
        </tspan>
      </text>
    </svg>
  );
};

export default TextBold;
